export default __webpack_public_path__ + "static/media/chem520.5f3322ee.svg";